var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bottom-bar',{attrs:{"liked":_vm.liked},on:{"toggle-like":_vm.toggleLike,"go-to-post":_vm.goToCollectionPost}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-829caa9e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom_bar/CollectionBottomBar.vue
// module id = 1595
// module chunks = 0